<template>
  <v-container fluid class="pt-0 mt-0">
    <v-form>
      <v-row>
        <v-spacer />
        <v-col cols="10">
          <h1>Create New Forum</h1>
        </v-col>
        <v-spacer />
      </v-row>

      <v-row>
        <v-spacer />
        <v-col cols="10">
          <v-text-field
            clearable
            outlined
            shaped
            persistent-hint
            label="What is your forum title?"
            hint="The title should be no more than 150 characters"
            counter="150"
            ref="title"
          >
          </v-text-field>
        </v-col>
        <v-spacer />
      </v-row>

      <v-row>
        <v-spacer />
        <v-col cols="10">
          <v-text-field
            clearable
            outlined
            shaped
            persistent-hint
            label="What is the forum description?"
            hint="The description should be no more than 150 characters"
            counter="150"
            ref="description"
          >
          </v-text-field>
        </v-col>
        <v-spacer />
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="10" class="text-right">
          <v-btn class="ma-2 error" outlined to="/forumboardlist">Cancel</v-btn>
          <v-btn class="ma-2 green" outlined @click="submitNewForum()">
            Submit
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--right mdi mdi-email-newsletter theme--light"
              style="font-size: 16px"
            ></i>
          </v-btn>
        </v-col>
        <v-spacer />
      </v-row>
    </v-form>
  </v-container>
</template>

<script>

export default {
  data: () => ({}),
  methods: {
    submitNewForum() {
      this.$router.push("/forumboardlist");
    },
  },
};
</script>

<style>
</style>